<template>
  <section>
    <h2>Комната 4: {{ this.$store.state.Window4.nameWindow4 }}</h2>
    <v-row>
      <v-col
        cols="12"
        sm="3"
      >
        <v-img width="70%" src="/img/kar.jpg" class="mx-auto"/>
        <div class="d-table mx-auto">
          <v-radio-group v-model.lazy="karTypeSelected4" @change="calcKarniz4() || updateCostKarniz4()">
            <v-radio
              label="Настенный карниз"
              value="Настенный карниз"
            />
          </v-radio-group>
        </div>
      </v-col>
      <v-col
        cols="12"
        sm="3"
      >
        <v-img width="70%" src="/img/kar2.jpg" class="mx-auto"/>
        <div class="d-table mx-auto">
          <v-radio-group v-model.lazy="karTypeSelected4" @change="calcKarniz4() || updateCostKarniz4()">
            <v-radio
              :disabled="this.$store.state.Window4.windowTypeSelected4 === 'Эркерное окно'"
              label="Шина потолочная"
              value="Шина потолочная"
            />
          </v-radio-group>
        </div>
      </v-col>
      <v-col
        cols="12"
        sm="3"
      >
        <v-img width="70%" src="/img/no_karniz.jpg" class="mx-auto"/>
        <div class="d-table mx-auto">
          <v-radio-group v-model.lazy="karTypeSelected4" @change="calcKarniz4()">
            <v-radio
              label="Не нужен"
              value="Нет"
            />
          </v-radio-group>
        </div>
      </v-col>
      <v-col
        cols="12"
        sm="3"
        class="summaryCol"
      >
        <h2>Окно №4: {{ this.$store.state.Window4.nameWindow4 }}</h2>
        <h3 class="pt-5">Вы выбрали:</h3>
        <ul class="pt-5">
          <li v-if="this.$store.state.Window4.windowTypeSelected4"><span><b>Тип окна:</b></span> {{ this.$store.state.Window4.windowTypeSelected4 }}</li>
          <li v-if="this.$store.state.Window4.widthWindow4 && this.$store.state.Window4.heightWindow4"><span><b>Размер стены:</b></span> <span v-if="this.$store.state.Window4.widthWindow4 && this.$store.state.Window4.heightWindow4">{{ this.$store.state.Window4.widthWindow4 }}</span><span v-if="this.$store.state.Window4.widthWindow4 && this.$store.state.Window4.heightWindow4">*</span>{{ this.$store.state.Window4.heightWindow4 }}</li>
          <li v-if="this.$store.state.Curtains.modelCurtain4 "><b>Комплект штор: </b> {{ this.$store.state.Curtains.modelCurtain4 }}</li>
          <li v-if="this.$store.state.Tulles.kitTulles4Choosen"><b>Тюль/рулонная штора: </b>{{ this.$store.state.Tulles.kitTulles4Choosen }}</li>
          <li v-if="this.$store.state.Karniz.karTypeSelected4"><b>Карниз: </b>{{ this.$store.state.Karniz.karTypeSelected4 }}</li>
          <li v-if="costKarniz4"><b>Стоимость: {{ costKarniz4 }} руб.</b></li>
        </ul>
      </v-col>
    </v-row>
  </section>
</template>

<script>
export default {
  name: 'TypeKarniz4',
  data () {
    return {
    }
  },
  computed: {
    karTypeSelected4: {
      get () {
        return this.$store.state.Karniz.karTypeSelected4
      },
      set (value) {
        this.$store.commit('updateKarniz4', value)
      }
    },
    costKarniz4: {
      get () {
        return this.$store.state.Karniz.costKarniz4
      }
    }
  },
  methods: {
    calcKarniz4 () { // рассчет только тюли
      this.$store.commit('updateCostKarniz4')
    },
    updateCostKarniz4 () { // рассчет тюли от ширины
      this.$store.commit('updateCostStep5Karniz4')
    },
    updateCostStep4Karniz4WithErker () {
      this.$store.commit('updateCostStep4Karniz4WithErker')
    }
  }
}
</script>

<style>

</style>
